import React, { useState } from 'react';
import axios from 'axios';
export default function Login({view, setView}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    const {data} = await axios.post('https://megamont.pl/api/login', { email, password })
    if (data.status) {
      localStorage.setItem('adminUser', JSON.stringify(data.user));
      setView(1);
    } else {
      alert('Błędne dane logowania');
    }     
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center ">
      <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '15px' }}>
        <div className="card-body">
          <div className="text-center mb-4">
            <h2 className="fw-bold gradient-text">Panel Admina</h2>
            <p className="text-muted">Zaloguj się, aby zarządzać realizacjami</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label fw-600">Adres Email</label>
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="nazwa użytkownika"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-600">Hasło</label>
              <input
                type="password"
                className="form-control form-control-lg"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary btn-lg w-100 shadow-sm" style={{ borderRadius: '8px' }}>
              Zaloguj się
            </button>
          </form>

          <div className="text-center mt-4">
            <small className="text-muted">
              &copy; 2024 MegaMont Panel
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}